import React from 'react'
import { Button } from './components/buttons/Button'
import { Icon } from './Icon'

const NAV_SERVICES = [
  ['battery-charging', 'Battery Energy Storage', 'Residential → utility-scale ESS', 'bess'],
  ['forklift', 'Industrial Mobility Batteries', 'AGV, AMR, EV, marine & medical', 'mobility'],
  ['bot', 'Robotics Integration', 'Integration, welding, custom cells', 'robotics'],
  ['cog', 'Industrial Automation', 'Vision, PLC/HMI, smart factory', 'automation'],
  ['sun', 'Solar EPC Solutions', 'Rooftop, ground-mount, Solar+BESS', 'solar'],
  ['rocket', 'New Product Development', 'Defence, aerospace, marine, rail', 'npd'],
];

export function Navbar({ current, onNavigate, dark = false }) {
  const [scrolled, setScrolled] = React.useState(false);
  const [mega, setMega] = React.useState(false);
  const [mobile, setMobile] = React.useState(false);
  const [mobileServices, setMobileServices] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const menu = [
    ['Home', 'Home'], ['About Us', 'About'], ['Services', 'Services'],
    ['Industries', 'Industries'], ['Process', 'Process'], ['Partners', 'Partners'],
    ['Gallery', 'Gallery'], ['Certificates', 'Certifications'], ['Careers', 'Careers'], ['Contact', 'Contact'],
  ];
  const onDark = dark && !scrolled;
  const linkColor = onDark ? 'rgba(255,255,255,0.85)' : 'var(--text-body)';

  return (
    <header style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50, transition: 'all var(--dur-med) var(--ease-out)',
      background: scrolled ? 'var(--glass-light-bg)' : 'transparent',
      backdropFilter: scrolled ? 'blur(var(--glass-blur-strong))' : 'none',
      WebkitBackdropFilter: scrolled ? 'blur(var(--glass-blur-strong))' : 'none',
      borderBottom: scrolled ? '1px solid var(--glass-light-border)' : '1px solid transparent',
      boxShadow: scrolled ? 'var(--shadow-sm)' : 'none',
    }} onMouseLeave={() => setMega(false)}>
      <div style={{
        maxWidth: 'var(--container-xl)', margin: '0 auto',
        padding: scrolled ? '11px var(--gutter)' : '18px var(--gutter)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 20,
        transition: 'padding var(--dur-med) var(--ease-out)',
      }}>
        <a onClick={() => onNavigate('Home')} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
          <img src="/adirath-logo.webp" alt="ADIRATH" style={{ height: scrolled ? 32 : 38, transition: 'height var(--dur-med)' }} />
        </a>

        <nav className="adr-desktop-nav" style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {menu.map(([label, page]) => {
            const active = current === page || (page === 'Services' && current === 'Service');
            const isServices = page === 'Services';
            return (
              <div key={label} onMouseEnter={() => setMega(isServices)} style={{ position: 'relative' }}>
                <a onClick={() => onNavigate(page)} style={{
                  cursor: 'pointer', padding: '8px 10px', display: 'inline-flex', alignItems: 'center', gap: 5,
                  whiteSpace: 'nowrap', fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-sm)',
                  fontWeight: active ? 'var(--fw-bold)' : 'var(--fw-semibold)',
                  color: active ? (onDark ? '#fff' : 'var(--accent)') : linkColor, position: 'relative',
                }}>
                  {label}
                  {isServices && <Icon name="chevron-down" style={{ width: 14, height: 14, transform: mega ? 'rotate(180deg)' : 'none', transition: 'transform var(--dur-fast)' }} />}
                  {active && <span style={{ position: 'absolute', left: 13, right: 13, bottom: 1, height: 2, borderRadius: 2, background: 'var(--energy)' }} />}
                </a>
              </div>
            );
          })}
        </nav>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <a onClick={() => onNavigate('Portal')} className="adr-desktop-nav" style={{
            cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 12px',
            fontFamily: 'var(--font-ui)', fontWeight: 700, fontSize: 'var(--fs-sm)', color: onDark ? '#fff' : 'var(--text-strong)',
          }}>
            <Icon name="lock" style={{ width: 15, height: 15 }} /> Login
          </a>
          <div className="adr-nav-cta">
            <Button variant={onDark ? 'glass' : 'primary'} size="sm" iconRight={<Icon name="arrow-right" style={{ width: 16, height: 16 }} />} onClick={() => onNavigate('Contact')}>Get Consultation</Button>
          </div>
          <button aria-label="Menu" className="adr-mobile-toggle" onClick={() => { setMobile((m) => !m); setMobileServices(false); }} style={{
            display: 'none', width: 42, height: 42, borderRadius: 10, border: '1px solid var(--border-strong)',
            background: 'var(--surface-card)', cursor: 'pointer', alignItems: 'center', justifyContent: 'center',
          }}>
            <Icon name={mobile ? 'x' : 'menu'} style={{ width: 22, height: 22 }} />
          </button>
        </div>
      </div>

      {/* Services mega menu */}
      {mega && (
        <div className="adr-desktop-nav" style={{ position: 'absolute', left: 0, right: 0, top: '100%', display: 'flex', justifyContent: 'center', padding: '0 var(--gutter)' }}>
          <div className="adr-mega" style={{
            width: 'min(960px, 100%)', background: 'var(--surface-card)', borderRadius: '0 0 var(--radius-xl) var(--radius-xl)',
            border: '1px solid var(--border-subtle)', borderTop: 'none', boxShadow: 'var(--shadow-lg)', padding: 22,
            display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10,
          }}>
            {NAV_SERVICES.map(([ic, t, d, key]) => (
              <a key={key} onClick={() => { setMega(false); onNavigate({ page: 'Service', service: key }); }} style={{
                cursor: 'pointer', display: 'flex', gap: 12, padding: 14, borderRadius: 'var(--radius-md)', transition: 'background var(--dur-fast)',
              }} onMouseEnter={(e) => e.currentTarget.style.background = 'var(--surface-sunken)'} onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}>
                <span style={{ flexShrink: 0, width: 42, height: 42, borderRadius: 11, background: 'var(--accent-soft)', color: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Icon name={ic} style={{ width: 21, height: 21 }} />
                </span>
                <span>
                  <span style={{ display: 'block', fontFamily: 'var(--font-heading)', fontWeight: 700, fontSize: 14.5, color: 'var(--text-strong)' }}>{t}</span>
                  <span style={{ display: 'block', fontSize: 12.5, color: 'var(--text-muted)', marginTop: 2 }}>{d}</span>
                </span>
              </a>
            ))}
            <a onClick={() => { setMega(false); onNavigate('Services'); }} style={{ gridColumn: '1 / -1', marginTop: 4, padding: '12px 14px', borderRadius: 'var(--radius-md)', background: 'var(--accent-soft)', color: 'var(--accent)', fontFamily: 'var(--font-ui)', fontWeight: 700, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}>
              View all services <Icon name="arrow-right" style={{ width: 18, height: 18 }} />
            </a>
          </div>
        </div>
      )}

      {/* Mobile menu */}
      {mobile && (
        <div className="adr-mobile-menu" style={{ display: 'none', background: 'var(--surface-card)', borderTop: '1px solid var(--border-subtle)', padding: '8px var(--gutter) 20px', maxHeight: '80vh', overflowY: 'auto' }}>
          {[...menu, ['Client Portal', 'Portal']].map(([label, page]) => {
            const isServices = page === 'Services';
            const isActive = current === page || (page === 'Services' && current === 'Service');
            return (
              <React.Fragment key={label}>
                <a onClick={() => {
                    if (isServices) { setMobileServices((s) => !s); }
                    else { setMobile(false); setMobileServices(false); onNavigate(page); }
                  }}
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '13px 4px',
                    borderBottom: isServices && mobileServices ? '1px solid var(--border-subtle)' : '1px solid var(--border-subtle)',
                    fontFamily: 'var(--font-ui)', fontWeight: isActive ? 700 : 600,
                    color: isActive ? 'var(--accent)' : 'var(--text-strong)',
                    cursor: 'pointer',
                    background: isActive ? 'var(--accent-soft)' : 'transparent',
                    borderRadius: isActive ? 8 : 0,
                    paddingLeft: isActive ? 10 : 4,
                    paddingRight: isActive ? 10 : 4,
                    marginBottom: isActive ? 2 : 0,
                  }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    {isActive && <span style={{ width: 4, height: 4, borderRadius: '50%', background: 'var(--accent)', flexShrink: 0 }} />}
                    {label}
                  </span>
                  {isServices && (
                    <Icon name="chevron-down" style={{ width: 16, height: 16, color: 'var(--text-muted)', transform: mobileServices ? 'rotate(180deg)' : 'none', transition: 'transform var(--dur-fast)', flexShrink: 0 }} />
                  )}
                </a>

                {isServices && mobileServices && (
                  <div style={{ background: 'var(--surface-sunken)', borderRadius: 10, margin: '4px 0 6px', overflow: 'hidden', border: '1px solid var(--border-subtle)' }}>
                    <a onClick={() => { setMobile(false); setMobileServices(false); onNavigate('Services'); }}
                      style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '11px 14px', fontFamily: 'var(--font-ui)', fontWeight: 700, fontSize: 13, color: 'var(--accent)', cursor: 'pointer', borderBottom: '1px solid var(--border-subtle)' }}>
                      All Services <Icon name="arrow-right" style={{ width: 15, height: 15 }} />
                    </a>
                    {NAV_SERVICES.map(([ic, t, d, key]) => (
                      <a key={key} onClick={() => { setMobile(false); setMobileServices(false); onNavigate({ page: 'Service', service: key }); }}
                        style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '11px 14px', borderBottom: '1px solid var(--border-subtle)', cursor: 'pointer' }}
                        onMouseEnter={(e) => e.currentTarget.style.background = 'var(--surface-card)'}
                        onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}>
                        <span style={{ flexShrink: 0, width: 34, height: 34, borderRadius: 9, background: 'var(--accent-soft)', color: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <Icon name={ic} style={{ width: 17, height: 17 }} />
                        </span>
                        <span>
                          <span style={{ display: 'block', fontFamily: 'var(--font-ui)', fontWeight: 600, fontSize: 14, color: 'var(--text-strong)' }}>{t}</span>
                          <span style={{ display: 'block', fontSize: 11.5, color: 'var(--text-muted)', marginTop: 1, lineHeight: 1.35 }}>{d}</span>
                        </span>
                      </a>
                    ))}
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      )}
    </header>
  );
}
